<template>
    <div class="grid rounded-2xl p-4 items-center bg-white w-[20.8rem] border border-gray-500">
        <div>
            <div class="relative">
                <h1 class="font-bold text-primary text-center">Filtro</h1>
            </div>
            <div>
                <div v-show="currentFilterAttribute.data == 'regions'">
                    <ExpandableCheckbox
                        :options="computedRegions"
                        v-if="canSelectMultiplesRegions"
                        title="Regional"
                        placeholder="Selecione uma ou mais regiões"
                        class="max-w-[19rem]"
                        @updateValue="formFilter[1].value = $event"
                    />
                    <ExpandableRadio
                        v-else
                        :options="computedRegions"
                        title="Regional"
                        placeholder="Selecione uma ou mais regiões"
                        class="max-w-[19rem]"
                        @updateValue="formFilter[1].value = $event"
                    />
                    <label v-if="canSelectMultiplesRegions">
                        <input
                            class="mt-6 mb-2"
                            type="checkbox"
                            :value="true"
                            :onclick="() => (formFilter[1].value = true)"
                            v-model="formFilter[1].value"
                        />
                        Marcar todas
                    </label>
                </div>
                <div v-show="currentFilterAttribute.data == 'subregions'">
                    <ExpandableCheckbox
                        v-if="canSelectMultiplesSubregions"
                        :options="computedSubregions"
                        title="Sub-Regional"
                        placeholder="Selecione as sub-regionais"
                        class="max-w-[19rem]"
                        @updateValue="formFilter[2].value = $event"
                    />
                    <ExpandableRadio
                        v-else
                        :options="computedSubregions"
                        title="Sub-Regional"
                        placeholder="Selecione as sub-regionais"
                        class="max-w-[19rem]"
                        @updateValue="formFilter[2].value = $event"
                    />
                    <label v-if="canSelectMultiplesSubregions">
                        <input
                            class="mt-6 mb-2"
                            type="checkbox"
                            :value="true"
                            :onclick="() => (formFilter[2].value = true)"
                            v-model="formFilter[2].value"
                        />
                        Marcar todas
                    </label>
                </div>
                <div v-show="currentFilterAttribute.data == 'category'">
                    <ExpandableRadio
                        :options="computedCategories"
                        title="Categoria"
                        placeholder="Selecione uma categoria"
                        class="max-w-[19rem]"
                        @updateValue="formFilter[3].value = $event"
                    />
                    <label>
                        <input
                            class="mt-6 mb-2"
                            type="checkbox"
                            :value="true"
                            :onclick="() => (formFilter[3].value = true)"
                            v-model="formFilter[3].value"
                        />
                        Marcar todas
                    </label>
                </div>

                <div
                    class="flex flex-wrap justify-center gap-4"
                    v-if="isLast"
                >
                    <p>
                        Pronto! Selecione suas fotos favoritas clicando no
                        ícone.
                    </p>
                    <Icon name="EstrelaHover" />
                    <Button @click.prevent="sendSpecificFilter()"
                        >Ok</Button
                    >
                </div>

                <div v-else class="mt-4 flex gap-x-5">
                    <!-- <Button @click="previousFormFilterIndex()" class="w-1/2"
                        >Voltar</Button
                    > -->
                    <Button @click="nextFormFilterIndex()"
                        >Avançar</Button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import ExpandableCheckbox from "@/Components/ExpandableCheckbox.vue";
import SearchableExpandableRadio from "@/Components/SearchableExpandableRadio.vue";

const DATE = new Date();

export default {
    components: {
        Head,
        Head,
        Icon,
        Button,
        ExpandableRadio,
        ExpandableCheckbox,
        SearchableExpandableRadio,
    },

    props: {
        selectedContestData: Object,
        regions: Object,
        subregions: Object,
        participant: Object,
    },

    emits: ["updateFilter"],

    data() {
        return {
            categories: [],
            executions: [],
            formFilter: [
                { data: "campaign", value: this.selectedContestData },
                { data: "regions", value: "" },
                { data: "subregions", value: "" },
                { data: "category", value: "" },
            ],
            formFilterIndex: 1,
            currentFilterAttribute: "",
            isLast: false,
        };
    },
    async mounted() {

    this.currentFilterAttribute = this.formFilter[1];
        this.currentFilterAttribute = this.formFilter[1];
    },
    computed: {
        contestsAvailableToVote() {
            return this.$page.props.auth.user.contestJudges;
        },
        selectedContest() {
            return this.selectedContestData;
        },
        selectedRegions() {
            return this.formFilter[1]?.value;
        },
        selectedSubregions() {
            return this.formFilter[2]?.value;
        },
        selectedCategories() {
            return this.formFilter[3]?.value;
        },
        fetchRegionStatus() {
            let regions = this.selectedRegions;
            const contest = this.selectedContest;

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            if (isNationalStage || isNationalPodium) {
                return contest?.stage || 1;
            } else {
                if (regions === true || regions.length > 0 || regions?.id) {
                    if (regions === true) regions = this.computedRegions;
                    else if (regions.id) regions = [regions];
                    const region = regions?.length > 0 && regions[0];

                    return (
                        contest?.stage > region?.contestRegionStage
                            ? contest?.stage
                            : region?.contestRegionStage
                    ) || 1;
                } else {
                    return contest?.stage || 1;
                }
            }
        },
        computedRegions() {
            const avaibleContests = this.contestsAvailableToVote;
            const contestStage = this.selectedContest?.stage || 1;
            const contestRegionStages = this.selectedContest?.regionsStage;
            
            const hasNationalStage = this.selectedContest?.winningType === "N";
            const hasNationalPodium = this.selectedContest?.podiumType === "N";
            
            const normalizeMerchan = (v) => {
                const val = String(v ?? "N").toUpperCase();
                return val === "M" ? "N" : val; // M -> N
            };

            const participantMerchan = normalizeMerchan(this.participant?.merchanC);
            const regionWithStage = this.regions
                .map((region) => {
                    const { id, name } = region;

                    const contestRegionStage = contestRegionStages?.find(
                        ({ regionId: contestRegionStageRegionId }) => {
                            return region.id === contestRegionStageRegionId;
                        }
                    );

                    return {
                        id,
                        
                        name,
                        contestRegionStage: contestRegionStage?.stage || 1,
                        merchanC: normalizeMerchan(contestRegionStage?.merchanC ?? "N"),
                    };
                });

            return regionWithStage?.filter((region) => {
                const { contestRegionStage, merchanC } = region;

                if (contestRegionStage === 2 && merchanC !== participantMerchan) {
                    return false;
                }
                
                if(hasNationalStage && contestRegionStage === 3 && contestStage === 2) return false;
                if(hasNationalPodium && contestRegionStage === 4 && contestStage === 3) return false;

                const regionStageGreaterThanContestLimit =
                    this.selectedContest?.hasPodium
                        ? contestRegionStage > 4
                        : contestRegionStage > 3;

                const regionStageAllowed = avaibleContests.find(
                    (b) =>
                        this.selectedContest?.id == b.contestId &&
                        b.stage == contestRegionStage
                );

                if (
                    contestStage > contestRegionStage ||
                    regionStageGreaterThanContestLimit ||
                    !regionStageAllowed
                ) {
                    return false;
                } else {
                    return true;
                }
            });
        },
        computedSubregions() {
            let regions = this.selectedRegions;
            const contestStage = this.selectedContest?.stage || 1;
            const contestSubRegionStages = this.selectedContest?.regionsStage;
            const normalizeMerchan = (v) => {
                const val = String(v ?? "N").toUpperCase();
                return val === "M" ? "N" : val; // M -> N
            };

            const participantMerchan = normalizeMerchan(this.participant?.merchanC);

            const subregionWithStage = this.subregions
                .map((subregion) => {
                    const { id, name, regionId } = subregion;

                    const contestSubregionStage = contestSubRegionStages?.find(
                            ({ subregionId: stageSubregionId }) => {
                                return subregion.id == stageSubregionId;
                            }
                        );

                    return {
                        id,
                        name,
                        regionId,
                        contestSubregionStage: contestSubregionStage?.stage || 1,
                        merchanC: normalizeMerchan(contestSubregionStage?.merchanC ?? "N"),
                    };
                });

            const filteredSubegionWithStage = subregionWithStage?.filter((subregion) => {
                    const { contestSubregionStage, merchanC } = subregion;

                    if (contestSubregionStage === 2 && merchanC !== participantMerchan) {
                    return false;
                    }

                    const subregionStageGreaterThanContestLimit =
                        this.selectedContest?.hasPodium
                            ? contestSubregionStage > 4
                            : contestSubregionStage > 3;

                    if ((contestStage > contestSubregionStage) || subregionStageGreaterThanContestLimit)
                        return false;
                    else return true;
                });

            if (regions === true || regions.length > 0 || regions?.id) {
                if (regions === true) regions = this.computedRegions;
                else if (regions.id) regions = [regions];

                let subregionByRegion = regions.map((region) => {
                    const contestRegionStage = region.contestRegionStage;
                    const subregionsIntoRegionStage = filteredSubegionWithStage.filter(
                        (subregion) =>
                            subregion.regionId == region.id &&
                            subregion.contestSubregionStage == contestRegionStage
                    )

                    return subregionsIntoRegionStage;
                });

                let mergedSubregions = [].concat?.apply([], subregionByRegion);

                return mergedSubregions;
            } else {
                return filteredSubegionWithStage;
            }
        },
        canSelectMultiplesRegions() {
            const contest = this.selectedContest;

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            return isNationalStage || isNationalPodium;
        },
        canSelectMultiplesSubregions() {
            const contest = this.selectedContest;
            const contestStage = this.fetchRegionStatus;

            const isRegionalOrNationalStage =
                contestStage > 1 &&
                contestStage < 4 &&
                ["N", "R"].find((el) => el == contest?.winningType);
            const isRegionalOrNationalPodium =
                contestStage === 4 &&
                ["N", "R"].find((el) => el == contest?.podiumType);

            return isRegionalOrNationalStage || isRegionalOrNationalPodium;
        },
        computedCategories() {
            return this.selectedContestData?.categories.map((item) => ({
                name: item.description,
                id: item.id,
            }));
        },
        computedExecutions() {
            return this.selectedContestData?.executionTypes.map((item) => ({
                name: item.description,
                id: item.id,
                weight: item.weight,
            }));
        }
    },

    watch: {
        formFilterIndex: {
            handler(newValue) {
                this.currentFilterAttribute = this.formFilter[newValue];
            },
        },
    },

    methods: {
        handleName(contest) {
            return `${contest?.name} (${moment(contest?.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest?.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        sendSpecificFilter() {
            let regions = [];
            let allregions = false;
            let subregions = [];
            let allsubregions = false;
            let category = undefined;

            const selectedRegion = this.selectedRegions;
            const selectedSubregion = this.selectedSubregions;
            const selectedCategory = this.selectedCategories;

            if (selectedRegion === true) {
                regions = this.computedRegions;
                allregions = true;
            } else if (selectedRegion?.id) {
                regions = [selectedRegion];
            } else {
                regions = selectedRegion;
            }

            if (selectedSubregion === true) {
                subregions = this.computedSubregions;
                allsubregions = true;
            } else if (selectedSubregion?.id) {
                subregions = [selectedSubregion];
            } else {
                subregions = selectedSubregion;
            }

            if (selectedCategory === true) {
                category = undefined;
            } else {
                category = selectedCategory.id;
            }

            this.$emit("updateFilter", {
                campaign: this.selectedContestData.id,
                category,
                allregions,
                rawRegions: regions,
                regions: regions?.map((region) => region.id),
                allsubregions,
                rawSubregions: subregions,
                subregions: subregions?.map((subregion) => subregion.id),
                isVisible: 1,
            });

            this.formFilter = [
                { data: "campaign", value: this.selectedContestData},
                { data: "regions", value: "" },
                { data: "subregions", value: "" },
                { data: "category", value: "" },
            ];
        },
        async loadContest(contestId) {

            axios
                .get(`/contest/${contestId}`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(async ({ data }) => {
                    const { data: result } = await axios.get(
                        route("contest.get-all-regional-stage", {contestId})
                    );

                    this.formFilter[0].value = {
                        ...this.formFilter[0].value,
                        regionsStage: result?.regionalStages,
                    };



                    this.categories = data?.categories.map((item) => ({
                        name: item.description,
                        id: item.id,
                    }));
                    this.executions = data?.executionTypes.map((item) => ({
                        name: item.description,
                        id: item.id,
                        weight: item.weight,
                    }));
                });
        },
        nextFormFilterIndex() {
            if (
                this.formFilterIndex == 3 &&
                this.currentFilterAttribute.value
            ) {
                this.currentFilterAttribute = "";
                this.isLast = true;
                return;
            }

            if (Array.isArray(this.currentFilterAttribute.value)) {
                if (
                    this.currentFilterAttribute.value.length > 0 ||
                    this.currentFilterAttribute.value === true
                ) {
                    this.formFilterIndex++;
                }
                return;
            }
            this.currentFilterAttribute.value && this.formFilterIndex++;
        },
        previousFormFilterIndex() {
            this.formFilterIndex--;
            if (this.formFilterIndex === -1)
                location.href = route("photo-voting");
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scroll-bar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scroll-bar {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>
